import {observable, computed, autorun, toJS, action} from 'mobx';
import {getIn} from '../utils';
import moment from 'moment';

import * as constants from '../model/const';

class RecentBooking {
  constructor(content) {
    this.content = content;
  }

  @computed get id() {
    return getIn(this.content, ['Id']);
  }

  @computed get number() {
    return getIn(this.content, ['Number']);
  }

  @computed get objectName() {
    return getIn(this.content, ['Name']);
  }

  @computed get currency() {
    return getIn(this.content, ['Currency_Name']);
  }

  @computed get startDate() {
    return getIn(this.content, ['RentingStartDate']);
  }

  @computed get endDate() {
    return getIn(this.content, ['RentingEndDate']);
  }

  @computed get price() {
    return getIn(this.content, ['TotalDiscountedPrice']);
  }

  @computed get status() {
    return getIn(this.content, ['RentalTransactionStatus_Name']);
  }

  @computed get statusId() {
    return getIn(this.content, ['refRentalTransactionStatusId']);
  }    
}

export class VRecentBookings {
  @observable pageSize = 30;
  @observable pageNumber = 1;
  @observable canLoadMore = true;

  constructor(flasher, api, scene) {
    this.flasher = flasher;
    this.api = api; 
    this.scene = scene;
  }

  @observable recentBookingsContent = [];
  @observable displayFilter = constants.BOOKINGS_FILTER_TYPE.ACTIVE;

  @action.bound setDisplayFilter(filter) {
    this.displayFilter = filter;
    this.updateList();
  }

  @computed get recentBookings() {
    return this.recentBookingsContent.map(o => {
      return new RecentBooking(o);
    })
  }

  async updateList() {
    try {
      this.flasher.setOther('Loading.')
      this.canLoadMore = false;
      this.pageNumber = 1;
      switch(this.displayFilter) {
        case constants.BOOKINGS_FILTER_TYPE.ACTIVE:
          this.recentBookingsContent = await this.api.getRecentBookings({
            startDate: moment().startOf('day').toISOString(),
            endDate: moment().startOf('day').add({years: 100}).toISOString(),
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
            isActive: true
          });
          break;
        case constants.BOOKINGS_FILTER_TYPE.ARCHIVED:
          this.recentBookingsContent = await this.api.getRecentBookings({
            startDate: moment().startOf('day').subtract({years: 100}).toISOString(),
            endDate: moment().startOf('day').toISOString(),
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
            isActive: false            
          });
          break; 
        default:
          this.recentBookingsContent = await this.api.getRecentBookings({
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,   
            isActive: false           
          });
          break;                  
      }
      if(this.recentBookingsContent.length >= this.pageSize) {
        this.canLoadMore = true;
      }
    }
    finally {
      this.flasher.setOther()      
    }      
    
  }

  loadMore = async() => {
    try {
      this.flasher.setOther('Loading.')
      this.canLoadMore = false;
      this.pageNumber++;
      let items = [];
      switch(this.displayFilter) {
        case constants.BOOKINGS_FILTER_TYPE.ACTIVE:

          items = await this.api.getRecentBookings({
            startDate: moment().startOf('day').toISOString(),
            endDate: moment().startOf('day').add({years: 10}).toISOString(),
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
            isActive: true  
          });
          this.recentBookingsContent.push(...items);
          break;
        case constants.BOOKINGS_FILTER_TYPE.ARCHIVED:
          items = await this.api.getRecentBookings({
            startDate: moment().startOf('day').subtract({years: 10}).toISOString(),
            endDate: moment().startOf('day').toISOString(),
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,  
            isActive: false            
          });
          this.recentBookingsContent.push(...items);
          break;  
        default:
          items = await this.api.getRecentBookings({
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,     
            isActive: false         
          });
          this.recentBookingsContent.push(...items);
          break;                  
      }
      if(items.length >= this.pageSize) {
        this.canLoadMore = true;
      }
    }
    finally {
      this.flasher.setOther()      
    }  
  }

  startOrUpdate = async() => {
    await this.updateList();
  }

  stop() {

  }
} 


// WEBPACK FOOTER //
// ./src/view/VRecentBookings.js